import { render, staticRenderFns } from "./KsSeriesAuthorization.vue?vue&type=template&id=3cafa349&scoped=true"
import script from "./KsSeriesAuthorization.vue?vue&type=script&lang=js"
export * from "./KsSeriesAuthorization.vue?vue&type=script&lang=js"
import style0 from "./KsSeriesAuthorization.vue?vue&type=style&index=0&id=3cafa349&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cafa349",
  null
  
)

export default component.exports